var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopifyPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 212.77,
    height: 36.794,
    viewBox: "0 0 212.77 36.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4701",
    "data-name": "Rectangle 4701",
    width: 212.77,
    height: 36.794,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29006",
    "data-name": "Group 29006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29005",
    "data-name": "Group 29005",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141071",
    "data-name": "Path 141071",
    d: "M14.587,1.164c.258,0,.387.129.645.258-1.549.645-3.1,2.324-3.873,5.938l-2.84.775c.9-2.582,2.711-6.971,6.067-6.971m1.42,1.291a9,9,0,0,1,.516,3.1v.258L12.78,6.844c.775-2.711,2.065-3.873,3.227-4.389m3.356,2.324L17.686,5.3V4.908a8.872,8.872,0,0,0-.387-2.84,3.887,3.887,0,0,1,2.065,2.711m8.391,2.065a.278.278,0,0,0-.258-.258c-.258,0-2.969-.258-2.969-.258s-1.936-1.936-2.195-2.065c-.258-.258-.645-.129-.775-.129,0,0-.387.129-1.033.387-.645-1.807-1.807-3.486-3.744-3.486h-.129A2.283,2.283,0,0,0,14.717,0C10.069-.127,7.875,5.683,7.1,8.652,6.067,8.91,5.035,9.3,3.873,9.684c-1.033.258-1.033.387-1.162,1.291C2.582,11.621,0,32.018,0,32.018L20.526,35.89l11.1-2.453S27.755,7.1,27.755,6.844",
    transform: "translate(0 0.001)",
    fill: "#8db849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141072",
    "data-name": "Path 141072",
    d: "M22.742,5.655c-.129,0-2.84-.258-2.84-.258S17.965,3.46,17.707,3.331c-.129-.129-.129-.129-.258-.129L15.9,34.959,27,32.506S23.129,6.171,23.129,5.913c0-.129-.258-.258-.387-.258",
    transform: "translate(4.626 0.932)",
    fill: "#5a863e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141073",
    "data-name": "Path 141073",
    d: "M15.706,10.022l-1.42,4.131a6.121,6.121,0,0,0-2.711-.645c-2.195,0-2.324,1.291-2.324,1.678,0,1.807,4.906,2.582,4.906,6.971,0,3.486-2.195,5.68-5.164,5.68A7.1,7.1,0,0,1,3.7,25.642l.9-3.1A6.588,6.588,0,0,0,7.96,24.093a1.347,1.347,0,0,0,1.42-1.42c0-2.453-4-2.582-4-6.584,0-3.356,2.453-6.584,7.229-6.584a5.127,5.127,0,0,1,3.1.516",
    transform: "translate(1.076 2.761)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141074",
    "data-name": "Path 141074",
    d: "M36.375,18.828c-1.162-.645-1.678-1.162-1.678-1.807,0-.9.775-1.42,2.065-1.42a6.864,6.864,0,0,1,2.711.645l1.033-3.1s-.9-.775-3.615-.775c-3.873,0-6.455,2.195-6.455,5.293,0,1.807,1.291,3.1,2.84,4,1.291.775,1.807,1.291,1.807,2.065s-.645,1.549-1.936,1.549a9.347,9.347,0,0,1-3.615-.9l-1.033,3.1a8.17,8.17,0,0,0,4.26,1.033c3.873,0,6.713-1.936,6.713-5.422,0-1.936-1.42-3.356-3.1-4.26m15.62-6.584a5.87,5.87,0,0,0-4.647,2.324l1.678-8.778H44.637l-4.26,22.333h4.389l1.42-7.616c.516-2.84,2.065-4.647,3.486-4.647,1.033,0,1.42.645,1.42,1.678a9.771,9.771,0,0,1-.129,1.936l-1.678,8.778h4.389l1.678-9.036a23.184,23.184,0,0,0,.258-2.84c0-2.582-1.291-4.131-3.615-4.131m11.231,12.78c-1.549,0-2.065-1.291-2.065-2.84,0-2.453,1.291-6.584,3.615-6.584,1.549,0,2.065,1.291,2.065,2.582,0,2.84-1.291,6.842-3.615,6.842m2.195-12.78c-5.293,0-8.778,4.776-8.778,10.069a5.687,5.687,0,0,0,6.067,6.067c5.164,0,8.649-4.647,8.649-10.069,0-3.1-1.807-6.067-5.938-6.067M78.33,25.153a2.672,2.672,0,0,1-1.807-.645l.775-4.131c.516-2.711,1.936-4.518,3.485-4.518,1.291,0,1.807,1.291,1.807,2.453-.129,2.84-1.807,6.842-4.26,6.842m4.26-12.909a6.007,6.007,0,0,0-4.647,2.582L78.2,12.5H74.328a53.443,53.443,0,0,1-.9,5.809l-3.1,16.008h4.389l1.162-6.455h.129a5.575,5.575,0,0,0,2.582.516c5.164,0,8.52-5.293,8.52-10.586,0-2.84-1.291-5.551-4.518-5.551M93.3,6.047a2.482,2.482,0,0,0-2.453,2.582,2,2,0,0,0,2.065,2.195A2.437,2.437,0,0,0,95.5,8.242,2.1,2.1,0,0,0,93.3,6.047M87.237,28.122h4.389L94.6,12.631H90.206ZM105.7,12.631h-3.1l.129-.775c.258-1.549,1.162-2.84,2.582-2.84a4.261,4.261,0,0,1,1.42.258l.9-3.486A5.622,5.622,0,0,0,105.31,5.4a6.3,6.3,0,0,0-4.26,1.42,8.311,8.311,0,0,0-2.582,4.906l-.129.775H96.274l-.645,3.356h2.065L95.37,28.122h4.389l2.324-12.264h2.969Zm10.457,0s-2.711,6.842-4,10.586c-.129-1.162-1.033-10.586-1.033-10.586h-4.647l2.582,14.2a1.637,1.637,0,0,1-.129.775,7.456,7.456,0,0,1-2.324,2.582,9.058,9.058,0,0,1-2.453,1.291l1.162,3.744a9.369,9.369,0,0,0,4.26-2.324,28.569,28.569,0,0,0,5.68-8.649l5.293-11.489Z",
    transform: "translate(8.291 1.572)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141075",
    "data-name": "Path 141075",
    d: "M107.395,25.979a10.067,10.067,0,0,1-3.523-.656l.514-1.206c.182.076,4.553,1.871,7.24-1.292,2.413-2.845,3.4-6.288,2.639-9.212a2.278,2.278,0,0,0-2.024-1.66c-.787-.1-3.8-.74-6.4,4.192l-.9.129c2.024-3.829,4.815-5.938,7.453-5.622a3.607,3.607,0,0,1,3.14,2.631c.869,3.336-.217,7.22-2.908,10.389a6.6,6.6,0,0,1-5.227,2.307",
    transform: "translate(30.219 3.09)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141076",
    "data-name": "Path 141076",
    d: "M118.383,26.132a4.039,4.039,0,0,1-1.914-.491,4.1,4.1,0,0,1-2.178-3.648c.012-1.478.311-6.541,3.661-9.659,2.866-2.663,7.882-1.7,8.094-1.655l.634.127-.119.635c-.036.2-.936,5-1.612,7.58a9.744,9.744,0,0,1-4.334,6.416,3.968,3.968,0,0,1-2.232.695m5.3-14.342a7.161,7.161,0,0,0-4.836,1.5c-2.968,2.76-3.234,7.363-3.244,8.71a2.8,2.8,0,0,0,1.486,2.485,2.669,2.669,0,0,0,2.794-.136,8.5,8.5,0,0,0,3.8-5.665c.516-1.973,1.188-5.379,1.464-6.817a13.444,13.444,0,0,0-1.465-.081",
    transform: "translate(33.25 3.048)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141077",
    "data-name": "Path 141077",
    d: "M122.483,24.035l-1.31-.01a48.2,48.2,0,0,1,.509-7.192l1.264.342a45.846,45.846,0,0,0-.462,6.86",
    transform: "translate(35.253 4.898)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141078",
    "data-name": "Path 141078",
    d: "M127.451,15.956l-1.6,1.567c.475-2.841,2.635-7.046,6.575-7.047l-.005,1.31H132.4a4.613,4.613,0,0,0-4.947,4.17",
    transform: "translate(36.612 3.048)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4700",
    "data-name": "Rectangle 4700",
    width: 6.841,
    height: 1.31,
    transform: "translate(171.187 13.524)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141079",
    "data-name": "Path 141079",
    d: "M153.543,26.072h-.01a3.973,3.973,0,0,1-3.061-1.368c-1.185-1.348-1.677-3.609-1.346-6.2.522-4.118,3.355-7.6,6.589-8.1a3.275,3.275,0,0,1,3.519,1.709,3.817,3.817,0,0,1-.729,4.4c-1.891,1.951-4.412,2.01-7.083,2.073-.324.008-.655.015-.99.027,0,.018,0,.036-.006.054-.283,2.223.094,4.108,1.031,5.174a2.658,2.658,0,0,0,2.08.924h.009a9.238,9.238,0,0,0,3.861-1.021l.64,1.144a10.586,10.586,0,0,1-4.5,1.186m2.778-14.412a2.611,2.611,0,0,0-.407.032c-2.284.354-4.4,2.7-5.211,5.6l.687-.018c2.6-.062,4.656-.111,6.173-1.674a2.51,2.51,0,0,0,.506-2.893,1.881,1.881,0,0,0-1.748-1.047",
    transform: "translate(43.356 3.012)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141080",
    "data-name": "Path 141080",
    d: "M148.681,11.407a3.073,3.073,0,0,0-2.439-1.026h-.028c-3.541,0-6.378,3.946-6.857,6.788l1.483-.954a5.631,5.631,0,0,1,5.375-4.523h.019a1.8,1.8,0,0,1,1.448.565c.862,1.013.627,3.293.373,4.92-.347,2.232-1.224,7.125-1.543,8.888h1.331c.347-1.927,1.171-6.53,1.507-8.687.318-2.041.527-4.563-.67-5.971",
    transform: "translate(40.543 3.021)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141081",
    "data-name": "Path 141081",
    d: "M127.4,10.424l-1.3,7.406c-.484,2.754-1.086,6.673-1.319,8.221h1.325c.253-1.66.824-5.365,1.284-7.995l1.34-7.632Z",
    transform: "translate(36.303 3.033)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141082",
    "data-name": "Path 141082",
    d: "M161.331,15.956l-1.6,1.567c.475-2.841,2.635-7.046,6.575-7.047l-.005,1.31h-.018a4.613,4.613,0,0,0-4.947,4.17",
    transform: "translate(46.469 3.048)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141083",
    "data-name": "Path 141083",
    d: "M161.283,10.424l-1.3,7.406c-.484,2.754-1.086,6.673-1.319,8.221h1.324c.253-1.66.824-5.365,1.284-7.995l1.34-7.632Z",
    transform: "translate(46.16 3.033)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141084",
    "data-name": "Path 141084",
    d: "M103.936,31.968l3.674-21.543h-1.33l-3.674,21.543Z",
    transform: "translate(29.851 3.033)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141085",
    "data-name": "Path 141085",
    d: "M140.739,10.424c-.136,1.006-.612,4.469-1.127,7.406-.488,2.777-1.239,6.7-1.532,8.221h1.334c.323-1.676,1.025-5.356,1.488-7.995.556-3.167,1.066-6.935,1.159-7.632Z",
    transform: "translate(40.171 3.033)",
    fill: "#1a1919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141086",
    "data-name": "Path 141086",
    d: "M134.806,25.547a.55.55,0,0,1-.478-.2c-.2-.236-.6-1.07-.111-3.7.453-2.433,2.409-12.381,2.724-13.987L135.368,9.2c-.44,2.238-2,9.878-2.437,12.2-.441,2.37-.314,3.935.391,4.782a1.866,1.866,0,0,0,1.485.673,2.979,2.979,0,0,0,2.579-1.057l-1.078-.742a1.873,1.873,0,0,1-1.5.489",
    transform: "translate(38.599 2.228)",
    fill: "#1a1919"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyPartner);
export default __webpack_public_path__ + "static/media/Shopify-Partner.ed62e3f995d1fc5d2260ba8fb02c6d6c.svg";
export { ForwardRef as ReactComponent };